import { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";
import { translations } from "@/i18n/translations";

const I18nContext = createContext({
  lang: "en",
  t: (k) => k,
  localePath: (p) => p,
  stripLang: (p) => p,
});

export const useI18n = () => useContext(I18nContext);

// Language is driven entirely by the URL prefix `/es`. English lives at the root.
// This keeps SEO clean (each language has its own indexable URL) and needs no state.
export function LanguageProvider({ children }) {
  const { pathname } = useLocation();
  const lang = pathname === "/es" || pathname.startsWith("/es/") ? "es" : "en";

  const t = (key) => {
    const dict = translations[lang] || {};
    if (Object.prototype.hasOwnProperty.call(dict, key)) return dict[key];
    return Object.prototype.hasOwnProperty.call(translations.en, key) ? translations.en[key] : key;
  };

  // Prefix an English path with the active language (used by internal links).
  const localePath = (p) => {
    if (lang !== "es") return p;
    if (p === "/") return "/es";
    return `/es${p}`;
  };

  // Remove the language prefix from a path (used by the language switcher).
  const stripLang = (p) => {
    if (p === "/es") return "/";
    if (p.startsWith("/es/")) return p.slice(3);
    return p;
  };

  return (
    <I18nContext.Provider value={{ lang, t, localePath, stripLang }}>
      {children}
    </I18nContext.Provider>
  );
}
